
#app2 img, #app3 img {
  width: 100px;
}